<!--
  @修改人：黎柏祺
  @修改时间：2018-10-28
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @负责人：libaiqi
  @创建日期：2018-9-18
  @版本号：V1.0.21
  @描述： 新建版本
-->
<template>
  <div class="createVersion__content">
    <back :history="history"></back>
    <div class="createVersion__operation">
      <el-button type="primary"  @click="e_submitVersion" v-g-rac="gRac('programPackage@submit')">{{ $t('packageManage.submitVersion') }}</el-button>
      <el-button type="primary"  @click="e_cancle">{{ $t('packageManage.cancle') }}</el-button>
    </div>
    <div class="createVersion__info">
      <span class='createVersion__info--text'>{{packageName}}</span>
      <span >{{$t('packageManage.installPath')}}：{{deployPath}}/{{packageName}}<span v-show="form.version!==''">/</span>{{form.version}}</span>
    </div>
    <div class="createVersion__form">
      <el-form ref="form" :model="form" :inline="true" label-width="80px" :rules="rules">
        <el-form-item :label="$t('packageManage.site')" prop="site" input-width="200px">
          <el-select v-model="form.site">
            <el-option v-for="(item,index) in siteList" :label="item" :value="index" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('packageManage.distributeSite')" prop="distributeSite" input-width="300px">
          <el-checkbox-group v-model="form.distributeSite">
            <el-checkbox v-for="(item,index) in siteList" :label="index" :key="index">{{item}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('packageManage.version')" prop="version" input-width="200px">
          <el-input v-model="form.version"  :placeholder="$t('packageManage.version')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('packageManage.desc')" input-width="200px">
          <el-input v-model="form.desc" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('packageManage.type')" prop="type" input-width="200px">
          <el-radio-group v-model="form.type" class="createVersion__radio">
            <el-radio :label="index" v-for="(item,index) in typeList" :key="index">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('packageManage.preVersion')" prop="preVersion" input-width="200px">
          <el-select v-model="form.preVersion">
            <el-option v-for="(item,index) in versionList" :label="item" :value="index" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form> 
    </div>
    <div class="createVersion__tabs">
      <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabName">
        <el-tab-pane :label="$t('packageManage.fileInfo')" :name="$t('packageManage.fileInfo')">
          <div class="createVersion__isSetPath" v-show="!isUpload&&path!==''">
              {{$t('packageManage.setPath')}} : {{path}}
          </div>
          <div class="createVersion__isSetPath" v-show="isUpload&&packagePath!==''">
              {{$t('packageManage.packagePath')}} : {{packagePath}}
          </div>
          <el-upload
            class="createVersion__upload"
            ref="upload"
            :action="uploadUrl"
            :before-remove="beforeRemove"
            :on-change="handleChange"
            :on-success="uploadSuccess"
            :on-error = "uploadFail"
            :data="uploadData"
            :auto-upload="false"
            multiple
            name="files"
            :file-list="fileList">
            <el-button size="small" type="primary" slot="trigger">{{$t('packageManage.uploadFile')}}</el-button>
            <el-button size="small" type="primary" @click="setPath">{{$t('packageManage.setPath')}}</el-button>
          </el-upload>
          <el-dialog :closeOnClickModal="false" :title="$t('packageManage.setPath')" :visible.sync="dialogFormVisible" width="500px ">
            <el-form :model="pathForm" label-position="left" label-width="70px" ref="pathForm">
              <el-form-item :label="$t('packageManage.example')">
                <el-input  v-model="example" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item :label="$t('packageManage.path')" prop="path">
                <el-input v-model="pathForm.path" ></el-input>
              </el-form-item>
              <el-form-item :label="$t('packageManage.result')" v-show="resultDesc!==''">
                <span :class="resultCode==='00000000'?'text-success':'text-danger'" >{{resultDesc}}</span>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="checkPath" v-g-rac="gRac('programPackage@checkPath')">{{$t('packageManage.check')}}</el-button>
              <el-button type="primary" @click="confirmPath">{{$t('packageManage.confirm')}}</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane :label="$t('packageManage.processInfo')"  :name="$t('packageManage.processInfo')">
            <el-form :model="processInfo" label-position="left" label-width="120px" ref="processInfo">
              <el-form-item :label="$t('packageManage.host')">
                <el-input  v-model="processInfo.host"></el-input>
              </el-form-item>
              <el-form-item :label="$t('packageManage.pid')">
                <el-input v-model="processInfo.pid" ></el-input>
              </el-form-item>
              <el-form-item :label="$t('packageManage.port')">
                <el-input  v-model="processInfo.port"></el-input>
              </el-form-item>
              <el-form-item :label="$t('packageManage.portException')">
                  <el-select v-model="processInfo.portException">
                    <el-option :label="item" :value="index" v-for="(item,index) in processType" :key="index"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item :label="$t('packageManage.processException')">
                  <el-select v-model="processInfo.processException">
                    <el-option :label="item" :value="index" v-for="(item,index) in processType" :key="index"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item :label="$t('packageManage.checkScript')">
                  <el-select v-model="processInfo.checkScript.langurage" size="small" class="createVersion__lan" @change="lanChangeA">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                    <codemirror :value="processInfo.checkScript.content"
                      :options="editorOptions"
                      @change="codeChangeA"
                      v-if="showProcessInfo"   
                    ></codemirror>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('packageManage.startupScript')" >
                  <el-select v-model="processInfo.startupScript.langurage" size="small" class="createVersion__lan" @change="lanChangeB">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="processInfo.startupScript.content"
                        :options="editorOptions"
                        @change="codeChangeB"
                        v-if="showProcessInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('packageManage.stopScript')">
                  <el-select v-model="processInfo.stopScript.langurage" size="small" class="createVersion__lan" @change="lanChangeC">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="processInfo.stopScript.content"
                        :options="editorOptions"
                        @change="codeChangeC"
                        v-if="showProcessInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('packageManage.installInfo')" :name="$t('packageManage.installInfo')">
            <el-form :model="installInfo" label-position="left" label-width="120px" ref="installInfo">
              <el-form-item :label="$t('packageManage.preInstallScript')">
                  <el-select v-model="installInfo.preInstallScript.langurage" size="small" class="createVersion__lan" @change="lanChangeD">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="installInfo.preInstallScript.content"
                        :options="editorOptions"
                        @change="codeChangeD"
                        v-if="showInstallInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('packageManage.afterInstallScript')">
                  <el-select v-model="installInfo.afterInstallScript.langurage" size="small" class="createVersion__lan" @change="lanChangeE">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="installInfo.afterInstallScript.content"
                        :options="editorOptions"
                        @change="codeChangeE"
                        v-if="showInstallInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('packageManage.updateInfo')" :name="$t('packageManage.updateInfo')">
            <el-form :model="installInfo" label-position="left" label-width="120px" ref="updateInfo">
              <el-form-item :label="$t('packageManage.preUpgradeScript')">
                  <el-select v-model="installInfo.preUpgradeScript.langurage" size="small" class="createVersion__lan" @change="lanChangeF">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="installInfo.preUpgradeScript.content"
                        :options="editorOptions"
                        @change="codeChangeF"
                        v-if="showUpdateInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('packageManage.afterUpgradeScript')">
                  <el-select v-model="installInfo.afterUpgradeScript.langurage" size="small" class="createVersion__lan" @change="lanChangeG">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="installInfo.afterUpgradeScript.content"
                        :options="editorOptions"
                        @change="codeChangeG"
                        v-if="showUpdateInfo"   
                      ></codemirror>
                  </div>
              </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('packageManage.advanced')" :name="$t('packageManage.advanced')"> 
          <el-form :model="advanced" label-position="left" label-width="120px" ref="advanced">
              <el-form-item :label="$t('packageManage.rollbackScript')">
                  <el-select v-model="advanced.rollbackScript.langurage" size="small" class="createVersion__lan" @change="lanChangeH">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="advanced.rollbackScript.content"
                        :options="editorOptions"
                        @change="codeChangeH"
                        v-if="showAdvanced"   
                      ></codemirror>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('packageManage.afterRollbackScript')">
                  <el-select v-model="advanced.afterRollbackScript.langurage" size="small" class="createVersion__lan" @change="lanChangeI">
                    <el-option :label="item" :value="index" v-for="(item,index) in scriptType" :key="index"></el-option>
                  </el-select>
                  <div class="code-editor-wrap">
                      <codemirror :value="advanced.afterRollbackScript.content"
                        :options="editorOptions"
                        @change="codeChangeI"
                        v-if="showAdvanced"   
                      ></codemirror>
                  </div>
              </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('packageManage.uclConfig')" :name="$t('packageManage.uclConfig')"> 
          <div class="createVersion__halfWidth">
              <el-form :model="uclConfig" label-position="left" label-width="120px" ref="uclConfig" :inline="true">
                <el-form-item :label="$t('packageManage.bindConfig')">
                    <el-button type="text"  @click="e_select">{{ $t('packageManage.select') }}</el-button>
                </el-form-item>
                <el-form-item :label="$t('packageManage.env')">
                  <el-input disabled v-model="envName" ></el-input>
                </el-form-item>
                <el-form-item :label="$t('packageManage.app')">
                  <el-input disabled v-model="uclConfig.appName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('packageManage.version')">
                  <el-input disabled v-model="uclVersion"></el-input>
                </el-form-item>
                <el-form-item :label="$t('packageManage.configList')" input-width="100%">
                  <el-table
                    :data="configList"
                    border
                    style="width: 100%"
                    >
                    <el-table-column
                      prop="key"
                      :label="$t('packageManage.key')"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="path"
                      :label="$t('packageManage.path')">
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-form>
              <el-dialog :closeOnClickModal="false" :title="$t('packageManage.selectConfig')" :visible.sync="formVisible">
                  <el-form label-position="left" label-width="120px" ref="configForm">
                    <el-form-item :label="$t('packageManage.app')">
                      <el-input disabled v-model="uclConfig.appName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('uclConfig.env')">
                      <el-select v-model="uclConfig.envId" @change="envChange">
                        <el-option :label="item" :value="index" v-for="(item,index) in envList" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('uclConfig.version')" >
                      <el-select v-model="uclConfig.version">
                        <el-option :label="item" :value="index" v-for="(item,index) in uclVersionList" :key="index"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="resetConfigForm">{{$t('common.cancel')}}</el-button>
                    <el-button type="primary" @click="setBind">{{$t('common.confirm')}}</el-button>
                  </div>
                </el-dialog>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>
<script>
  import dic from '@/components/mixins/dic'
  import back from '@/components/back'
  import packageManageBiz from '@/logic/continuousDelivery/programPackageManageBiz.js'
  import rac from '@/plugins/rac-mixin.js'
  import uclConfigBiz from '@/logic/continuousDelivery/uclConfigBiz.js'
  import { Loading } from 'uke-ui'
  export default {
    mixins: [dic, rac],
    data () {
      const that = this
      return {
        form: {
          version: '',
          desc: '',
          type: '',
          preVersion: '',
          distributeSite: [],
          site: ''
        },
        pathForm: {
          path: ''
        },
        processInfo: {
          host: '',
          pid: '',
          port: '',
          portException: '',
          processException: '',
          startupScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          stopScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          checkScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        },
        installInfo: {
          afterInstallScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          afterUpgradeScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          preInstallScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          preUpgradeScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        },
        advanced: {
          rollbackScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          afterRollbackScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        },
        uclConfig: {
          groupId: '',
          appName: '',
          version: '',
          envId: ''
        },
        formVisible: false,
        tabName: that.$t('packageManage.fileInfo'),
        history: [],
        packageName: '',
        deployPath: '',
        packagePath: '',
        typeList: {},
        fileList: [],
        siteList: {},
        uploadUrl: '/ops/appPackage/fileImport',
        example: '/uCloudlink/OPS',
        editorOptions: {
          tabSize: 2,
          styleActiveLine: false,
          lineNumbers: true,
          line: true,
          theme: 'idea',
          foldGutter: true,
          styleSelectedText: true,
          gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
          mode: 'text/x-sh',
          matchBrackets: true,
          showCursorWhenSelecting: true
        },
        dialogFormVisible: false,
        scriptType: {},
        processType: {},
        uploadData: {},
        rules: {
          version: [
            { required: true, message: that.$t('packageManage.rules.version'), trigger: 'blur' }
          ],
          type: [
            { required: true, message: that.$t('packageManage.rules.type'), trigger: 'change' }
          ],
          distributeSite: [
            { required: true, message: that.$t('packageManage.rules.distributeSite'), trigger: 'change' }
          ],
          site: [
            { required: true, message: that.$t('packageManage.rules.site'), trigger: 'change' }
          ]
        },
        isUpload: true,
        resultDesc: '',
        resultCode: '',
        versionList: {},
        path: '',
        id: '',
        showProcessInfo: false,
        showInstallInfo: false,
        showAdvanced: false,
        fileInfoTab: true,
        showUpdateInfo: false,
        envList: {},
        uclVersionList: {},
        configList: [],
        envName: '',
        uclVersion: '',
        responseList: [],
        loading: null,
        totalData: {}
      }
    },
    components: {
      back
    },
    methods: {
      e_init () {
        this.packageName = this.$route.query.packageName
        this.history = []
        if (this.$route.query.from === 'packageConfig') {
          this.history.push({ name: this.$t('packageManage.packageConfig'), path: '/home/programPackageManage/packageConfig?packageName=' + this.$route.query.packageName + '&pkId=' + this.$route.query.pkId })
          if (this.$route.query.isClone) {
            this.history.push({ name: this.$t('packageManage.cloneVersion') })
          } else {
            this.history.push({ name: this.$route.query.version ? this.$t('packageManage.editVersion') : this.$t('packageManage.createVersion') })
          }
        } else {
          this.history.push({ name: this.$t('packageManage.packageManage') })
        }
        this.waitScriptType()
        this.waitSiteList()
        this.waitErrorProcessType()
        this.waitAppPackageType()
        this.setDeployPath()
        this.getVersion()
        uclConfigBiz.getEnvList().then((data) => {
          let dataList = data.dataList
          let list = {}
          if (dataList.length !== 0) {
            for (let i = 0; i < dataList.length; i++) {
              list[dataList[i].id] = dataList[i].name
            }
            this.envList = {...list}
            if (Object.keys(this.envList).length !== 0) {
              if (this.$route.query.version !== undefined) return
              setTimeout(() => {
                this.getUclVersionList(Object.keys(this.envList)[0])
              }, 200)
            }
          }
        })
        if (this.$route.query.version !== undefined) {
          setTimeout(() => {
            this.getData()
          }, 100)
        }
      },
      async waitErrorProcessType () {
        await this.dGetDictionaryByCode('errorProcessType')
        this.processType = { ...this.dDictionary.errorProcessType }
      },
      async waitSiteList () {
        await this.dGetDictionaryByCode('remoteconfig')
        this.siteList = { ...this.dDictionary.remoteconfig }
        this.form.site = Object.keys(this.siteList)[0]
      },
      async waitAppPackageType () {
        await this.dGetDictionaryByCode('appPackageType')
        this.typeList = { ...this.dDictionary.appPackageType }
        this.form.type = Object.keys(this.typeList)[0]
      },
      async waitScriptType () {
        await this.dGetDictionaryByCode('scriptType')
        this.scriptType = { ...this.dDictionary.scriptType }
      },
      getUclVersionList (val) {
        uclConfigBiz.getVersionList({
          groupId: this.uclConfig.groupId,
          envId: val,
          appName: this.uclConfig.appName
        }, true).catch((data) => {
          let list = {}
          data.page.result.forEach((item) => {
            list[item] = item
          })
          this.uclVersionList = {...list}
          this.uclConfig.version = Object.keys(this.uclVersionList).length !== 0 ? Object.keys(this.uclVersionList)[0] : ''
        })
      },
      getConfigList (val) {
        if (!val) return
        uclConfigBiz.getConfigList({
          groupId: this.uclConfig.groupId,
          envId: val,
          version: this.uclVersion,
          appName: this.uclConfig.appName
        }).then((data) => {
          data.dataList.forEach((item) => {
            item.path = item.dir !== '' && item.dir !== null ? item.dir : item.defaultDir
          })
          this.configList = data.dataList
        })
      },
      envChange (val) {
        this.getUclVersionList(val)
      },
      resetConfigForm () {
        this.formVisible = false
      },
      lanChangeA (val) {
        if (val === 'Shell') {
          this.processInfo.checkScript.content = `#!/bin/bash\n${this.processInfo.checkScript.content}`
        } else {
          this.processInfo.checkScript.content = this.processInfo.checkScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.processInfo.checkScript.content.replace('#!/bin/bash\n', '') : this.processInfo.checkScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeB (val) {
        if (val === 'Shell') {
          this.processInfo.startupScript.content = `#!/bin/bash\n${this.processInfo.startupScript.content}`
        } else {
          this.processInfo.startupScript.content = this.processInfo.startupScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.processInfo.startupScript.content.replace('#!/bin/bash\n', '') : this.processInfo.startupScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeC (val) {
        if (val === 'Shell') {
          this.processInfo.stopScript.content = `#!/bin/bash\n${this.processInfo.stopScript.content}`
        } else {
          this.processInfo.stopScript.content = this.processInfo.stopScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.processInfo.stopScript.content.replace('#!/bin/bash\n', '') : this.processInfo.stopScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeD (val) {
        if (val === 'Shell') {
          this.installInfo.preInstallScript.content = `#!/bin/bash\n${this.installInfo.preInstallScript.content}`
        } else {
          this.installInfo.preInstallScript.content = this.installInfo.preInstallScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.installInfo.preInstallScript.content.replace('#!/bin/bash\n', '') : this.installInfo.preInstallScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeE (val) {
        if (val === 'Shell') {
          this.installInfo.afterInstallScript.content = `#!/bin/bash\n${this.installInfo.afterInstallScript.content}`
        } else {
          this.installInfo.afterInstallScript.content = this.installInfo.afterInstallScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.installInfo.afterInstallScript.content.replace('#!/bin/bash\n', '') : this.installInfo.afterInstallScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeF (val) {
        if (val === 'Shell') {
          this.installInfo.preUpgradeScript.content = `#!/bin/bash\n${this.installInfo.preUpgradeScript.content}`
        } else {
          this.installInfo.preUpgradeScript.content = this.installInfo.preUpgradeScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.installInfo.preUpgradeScript.content.replace('#!/bin/bash\n', '') : this.installInfo.preUpgradeScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeG (val) {
        if (val === 'Shell') {
          this.installInfo.afterUpgradeScript.content = `#!/bin/bash\n${this.installInfo.afterUpgradeScript.content}`
        } else {
          this.installInfo.afterUpgradeScript.content = this.installInfo.afterUpgradeScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.installInfo.afterUpgradeScript.content.replace('#!/bin/bash\n', '') : this.installInfo.afterUpgradeScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeH (val) {
        if (val === 'Shell') {
          this.advanced.rollbackScript.content = `#!/bin/bash\n${this.advanced.rollbackScript.content}`
        } else {
          this.advanced.rollbackScript.content = this.advanced.rollbackScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.advanced.rollbackScript.content.replace('#!/bin/bash\n', '') : this.advanced.rollbackScript.content.replace('#!/bin/bash', '')
        }
      },
      lanChangeI (val) {
        if (val === 'Shell') {
          this.advanced.afterRollbackScript.content = `#!/bin/bash\n${this.advanced.afterRollbackScript.content}`
        } else {
          this.advanced.afterRollbackScript.content = this.advanced.afterRollbackScript.content.indexOf('#!/bin/bash\n') !== -1 ? this.advanced.afterRollbackScript.content.replace('#!/bin/bash\n', '') : this.advanced.afterRollbackScript.content.replace('#!/bin/bash', '')
        }
      },
      codeChangeA (val) {
        this.processInfo.checkScript.content = val
      },
      codeChangeB (val) {
        this.processInfo.startupScript.content = val
      },
      codeChangeC (val) {
        this.processInfo.stopScript.content = val
      },
      codeChangeD (val) {
        this.installInfo.preInstallScript.content = val
      },
      codeChangeE (val) {
        this.installInfo.afterInstallScript.content = val
      },
      codeChangeF (val) {
        this.installInfo.preUpgradeScript.content = val
      },
      codeChangeG (val) {
        this.installInfo.afterUpgradeScript.content = val
      },
      codeChangeH (val) {
        this.advanced.rollbackScript.content = val
      },
      codeChangeI (val) {
        this.advanced.afterRollbackScript.content = val
      },
      tabClick (e) {
        if (e.index === '1') {
          this.showProcessInfo = true
        }
        if (e.index === '2') {
          this.showInstallInfo = true
        }
        if (e.index === '3') {
          this.showUpdateInfo = true
        }
        if (e.index === '4') {
          this.showAdvanced = true
        }
      },
      e_submitVersion () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const data = {
              ...this.form,
              processInfo: {
                ...this.processInfo
              },
              installInfo: {
                ...this.installInfo
              },
              advanced: {
                ...this.advanced
              },
              uclConfig: {
                version: this.uclVersion,
                envId: this.uclConfig.envId,
                groupId: this.uclConfig.groupId,
                appName: this.uclConfig.appName
              }
            }
            data.appPackage = this.packageName
            data.preVersion = data.preVersion === 'noPreVersion' ? '' : data.preVersion
            if (!this.isUpload) {
              data.fileInfo = {
                files: [],
                path: this.path
              }
            } else {
              let files = []
              this.fileList.map((item, index, array) => {
                files.push(item.name)
              })
              data.fileInfo = {
                files: files,
                path: ''
              }
              this.totalData = data
              this.uploadData.appPackage = this.$route.query.packageName
              this.uploadData.version = data.version
              this.uploadData.type = data.type
              this.$refs.upload.submit()
              if (this.fileList.some(item => item.percentage !== undefined) && this.responseList.length === 0) {
                this.loading = Loading.service({
                  target: '.createVersion__content'
                })
                return
              }
            }
            this.totalData = data
            this.e_save(data)
          }
        })
      },
      e_save (data) {
        if (this.$route.query.version === undefined || this.$route.query.isClone) {
          packageManageBiz.saveRealase(data).then((d) => {
            this.successCallBack()
          })
        } else {
          data.id = this.id
          packageManageBiz.updateRealase(data).then((d) => {
            this.successCallBack()
          })
        }
      },
      successCallBack () {
        this.$message({
          message: this.$t('packageManage.success'),
          type: 'success'
        })
        this.$router.push({
          path: '/home/programPackageManage'
        })
      },
      uploadSuccess (response, file, fileList) {
        let uploadFile = this.fileList.filter(item => item.percentage !== undefined)
        this.responseList.push(response)
        if (this.responseList.length === uploadFile.length) {
          this.loading.close()
          this.e_save(this.totalData)
        }
      },
      uploadFail (err, file, fileList) {
        this.loading.close()
        this.$message({
          message: this.$t('packageManage.uploadFail'),
          type: 'warning'
        })
        console.error(err)
      },
      findKey (obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find(k => compare(obj[k], value))
      },
      setBind () {
        this.envName = this.envList[this.uclConfig.envId]
        this.uclVersion = this.uclConfig.version
        this.getConfigList(this.uclConfig.envId)
        this.formVisible = false
      },
      e_select () {
        this.formVisible = true
      },
      setDeployPath () {
        packageManageBiz.getAppPackage({ id: this.$route.query.pkId }).then((d) => {
          this.deployPath = d.deployPath
          this.uclConfig.appName = d.appName
          this.uclConfig.groupId = d.group
        })
      },
      getVersion () {
        const that = this
        packageManageBiz.findRelease({ packageName: that.$route.query.packageName }).then((data) => {
          data.dataList.map((item, index, array) => {
            if (item.version === '' || item.version === null) return
            that.versionList[item.version] = item.version
          })
          that.versionList.noPreVersion = that.$t('packageManage.none')
        })
      },
      getData () {
        packageManageBiz.findSingleRelease({version: this.$route.query.version, packageName: this.packageName}).then((data) => {
          this.id = data.id
          this.form = {
            version: data.version,
            type: data.type,
            desc: data.desc,
            preVersion: data.preVersion,
            site: data.site,
            distributeSite: data.distributeSite ? data.distributeSite : []
          }
          this.packagePath = data.fileInfo.deployPath
          if (data.uclConfig !== undefined && data.uclConfig !== null) {
            this.uclVersion = data.uclConfig.version
            this.envName = this.envList[data.uclConfig.envId]
            this.getConfigList(data.uclConfig.envId)
          } else {
            this.uclVersion = ''
            this.envName = ''
          }
          if (data.fileInfo.files.length !== 0) {
            this.isUpload = true
            data.fileInfo.files.map((item, index, array) => {
              this.fileList.push({name: item})
            })
          } else {
            this.isUpload = false
            this.path = data.fileInfo.path ? data.fileInfo.path : ''
            this.pathForm.path = data.fileInfo.path ? data.fileInfo.path : ''
          }
          this.processInfo = {
            host: data.processInfo.host,
            pid: data.processInfo.pid,
            port: data.processInfo.port,
            portException: this.processType[data.processInfo.portException],
            processException: this.processType[data.processInfo.processException],
            startupScript: {
              langurage: data.processInfo.startupScript.langurage,
              content: data.processInfo.startupScript.content
            },
            stopScript: {
              langurage: data.processInfo.stopScript.langurage,
              content: data.processInfo.stopScript.content
            },
            checkScript: {
              langurage: data.processInfo.checkScript.langurage,
              content: data.processInfo.checkScript.content
            }
          }
          this.installInfo = {
            afterInstallScript: {
              langurage: data.installInfo.afterInstallScript.langurage,
              content: data.installInfo.afterInstallScript.content
            },
            afterUpgradeScript: {
              langurage: data.installInfo.afterUpgradeScript.langurage,
              content: data.installInfo.afterUpgradeScript.content
            },
            preInstallScript: {
              langurage: data.installInfo.preInstallScript.langurage,
              content: data.installInfo.preInstallScript.content
            },
            preUpgradeScript: {
              langurage: data.installInfo.preUpgradeScript.langurage,
              content: data.installInfo.preUpgradeScript.content
            }
          }
          this.advanced = {
            rollbackScript: {
              langurage: data.advanced.rollbackScript.langurage,
              content: data.advanced.rollbackScript.content
            },
            afterRollbackScript: {
              langurage: data.advanced.afterRollbackScript.langurage,
              content: data.advanced.afterRollbackScript.content
            }
          }
        })
      },
      checkPath () {
        packageManageBiz.checkPath({ path: this.pathForm.path }).then((data) => {
          this.resultCode = '00000000'
          this.resultDesc = this.$t('packageManage.usefulPath')
        }).catch((error) => {
          this.resultDesc = error.resultDesc
          this.resultCode = error.resultCode
        })
      },
      confirmPath () {
        if (this.pathForm.path !== '' && this.resultCode === '00000000') {
          this.$refs.upload.clearFiles()
          this.path = this.pathForm.path
          this.isUpload = false
          this.dialogFormVisible = false
        } else {
          this.$message({
            message: this.$t('packageManage.rules.path'),
            type: 'warning'
          })
        }
      },
      beforeRemove (file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`).then(() => {
          let index = this.fileList.findIndex(item => item.name === file.name)
          this.fileList.splice(index, 1)
        }).catch(() => {})
      },
      handleChange (file, fileList) {
        this.isUpload = true
        if (file.size > 200 * 1024 * 1024) {
          this.$message({
            message: this.$t('packageManage.rules.size'),
            type: 'warning'
          })
          fileList.pop()
        }
        this.fileList = fileList
        this.path = ''
        this.resultCode = ''
        this.resultDesc = ''
      },
      setPath () {
        this.dialogFormVisible = true
      },
      e_cancle () {
        if (this.$route.query.from === 'packageConfig') {
          let query = {}
          query.pkId = this.$route.query.pkId
          query.packageName = this.$route.query.packageName
          this.$router.push({ path: '/home/programPackageManage/packageConfig', query: query })
        } else {
          this.$router.push({ path: '/home/programPackageManage' })
        }
      },
      resetForm () {
        this.history = []
        this.form = {
          version: '',
          desc: '',
          type: Object.keys(this.typeList)[0],
          preVersion: '',
          site: Object.keys(this.siteList)[0],
          distributeSite: []
        }
        this.pathForm = {
          path: ''
        }
        this.uclConfig = {
          version: '',
          groupId: '',
          appName: '',
          envId: ''
        }
        this.processInfo = {
          host: '',
          pid: '',
          port: '',
          portException: '',
          processException: '',
          startupScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          stopScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          checkScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        }
        this.installInfo = {
          afterInstallScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          afterUpgradeScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          preInstallScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          preUpgradeScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        }
        this.advanced = {
          rollbackScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          },
          afterRollbackScript: {
            langurage: 'Shell',
            content: '#!/bin/bash'
          }
        }
        this.tabName = this.$t('packageManage.fileInfo')
        this.deployPath = ''
        this.packagePath = ''
        this.fileList = []
        this.showProcessInfo = false
        this.showInstallInfo = false
        this.showUpdateInfo = false
        this.showAdvanced = false
        this.versionList = {}
        this.path = ''
        this.envName = ''
        this.responseList = []
        this.loading = null
        this.configList = []
        this.uclVersion = ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.initTable();
        this.e_init()
      })
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'createVersion' && (from.name === 'programPackageManage' || from.name === 'packageConfig')) {
          this.packageName = this.$route.query.packageName
          if (this.$route.query.version !== undefined) {
            this.resetForm()
            this.getVersion()
            this.setDeployPath()
            setTimeout(() => {
              this.getData()
            }, 500)
          } else {
            this.resetForm()
            this.getVersion()
            this.setDeployPath()
          }
          if (this.$route.query.from === 'packageConfig') {
            this.history.push({ name: this.$t('packageManage.packageConfig'), path: `/home/programPackageManage/packageConfig?packageName=${this.$route.query.packageName}&pkId=${this.$route.query.pkId}` })
            if (this.$route.query.isClone) {
              this.history.push({ name: this.$t('packageManage.cloneVersion') })
            } else {
              this.history.push({ name: this.$route.query.version ? this.$t('packageManage.editVersion') : this.$t('packageManage.createVersion') })
            }
          } else {
            this.history.push({ name: this.$t('packageManage.packageManage') })
          }
        }
      }
    }
  }
</script>
<style scoped>
  .createVersion__content .packageManage__tag{
    cursor:pointer;
  }
  .createVersion__content .createVersion__operation{
    margin:15px 0;
  }
  .createVersion__content .createVersion__info--text{
    font-size:26px;
    font-weight:700;
    margin-right:10px;
  }
  .createVersion__content .createVersion__form {
    width:800px;
    margin:15px 0;
  }
  .createVersion__content .createVersion__form .createVersion__radio{
    margin-right:43px;
  }
  .createVersion__content .createVersion__upload {
    width:350px;
    margin-top: 10px;
  }
  .createVersion__content .createVersion__lan{
    margin-left:500px;
  }
  .createVersion__content .createVersion__con{
    width:683px;
  }
  .createVersion__content .text-danger{
    color:#FF4949;
  }
  .createVersion__content .text-success{
    color:#13CE66;
  }
  .createVersion__content .mt-base{
    margin-top:10px;
  }
  .createVersion__content .code-editor-wrap {
      width: 680px;
      border: 1px #ddd solid;
  }
  .createVersion__content .code-editor-wrap .CodeMirror-gutters {
      background: #e7e9db;
  }
  .createVersion__content .code-editor-wrap .CodeMirror{
      height: 200px;
      background: #e7e9db;
  }
  .createVersion__content .createVersion__halfWidth {
    width: 50%;
  }
</style>
  
